
const selectors = {
    open: 'is-open',
    attrs: {
        drawer: 'data-embroidery-drawer',
        underlay: 'data-drawer-underlay',
        openDrawer: 'data-embroidery-drawer-open',
        closeDrawer: 'data-embroidery-drawer-close',
        buyBtn: 'data-add-to-cart',
        embroideryText: 'data-embroidery-text',
        emborideryAddCheckbox: 'data-embroidery-add-checkbox',
        embroideryImageText: 'data-embroidery-image-text'
    }

}

class EmbroideryDrawer {
    constructor() {
        this.embroideryDrawer = document.querySelector(`[${selectors.attrs.drawer}]`);
        this.embroideryDrawerButton = document.querySelector(`[${selectors.attrs.openDrawer}]`);
        this.embroideryDrawerCloseButton = this.embroideryDrawer?.querySelector(`[${selectors.attrs.closeDrawer}]`);
        this.embroideryDrawerBuyButton = this.embroideryDrawer?.querySelector(`[${selectors.attrs.buyBtn}]`);
        this.embroideryDrawerText = this.embroideryDrawer?.querySelector(`[${selectors.attrs.embroideryText}]`);
        this.embroideryDrawerImageText = this.embroideryDrawer?.querySelector(`[${selectors.attrs.embroideryImageText}]`);
        this.embroideryAddCheckbox = document.querySelector(`[${selectors.attrs.emborideryAddCheckbox}]`);
        this.productForm = document.querySelector("product-form");

        this.embroideryDrawerIsOpen = false;

        this.onBodyClickEvent = (evt) => this.onBodyClick(evt);
        this.openEmbroideryDrawer = () => this.openEmborideryDrawer(); // override this when calling from event listener

        this.init();
    }

    init() {
        if (!this.embroideryDrawerButton) return;

        //set form to button
        this.embroideryDrawerBuyButton.setAttribute('form', this.productForm.querySelector("form").getAttribute("id"));
        this.embroideryDrawerText.setAttribute('form', this.productForm.querySelector("form").getAttribute("id"));
        this.embroideryAddCheckbox.setAttribute('form', this.productForm.querySelector("form").getAttribute("id"));

        this.embroideryDrawerBuyButton.addEventListener("click", (e) => {
            e.preventDefault();

            document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                    detail: {
                        button: this.productForm.querySelector("[data-add-to-cart]")
                    },
                    bubbles: false,
                }),
            );

            this.closeEmbroideryDrawer();
        });

        const _this = this;
        this.embroideryDrawerButton.addEventListener("click", function () {
            _this.toggleEmbroideryDrawer();
        })

        this.embroideryDrawerCloseButton.addEventListener("click", function () {
            _this.closeEmbroideryDrawer();
        })

        this.embroideryDrawerText.addEventListener("keyup", function (event) {
            _this.onEmbroideryTextChange(event);
        })
    }

    onEmbroideryTextChange(event) {
        this.embroideryDrawerImageText.textContent = event.target.value;
        if (event.target.value == "") {
            this.embroideryDrawerImageText.textContent = "text";
        }
    }

    onBodyClick(event) {
        if (event.target.hasAttribute(selectors.attrs.underlay))
            this.closeEmbroideryDrawer();
    }

    closeEmbroideryDrawer() {
        if (!this.embroideryDrawer) return;
        if (!this.embroideryDrawer.classList.contains(selectors.open)) return;

        this.embroideryDrawerBuyButton.removeAttribute('form');
        this.embroideryDrawerText.removeAttribute('form');
        this.embroideryAddCheckbox.checked = false;
        this.embroideryAddCheckbox.removeAttribute('form');

        this.embroideryDrawerIsOpen = false;

        document.dispatchEvent(
            new CustomEvent("theme:embroidery:close", {
                bubbles: true,
            }),
        );

        // Cart elements animation reset
        this.embroideryDrawer.classList.remove(selectors.open);
        document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: true }),
        );
    }

    openEmborideryDrawer() {
        if (!this.embroideryDrawer || this.embroideryDrawerIsOpen) return;

        this.embroideryDrawerBuyButton.setAttribute('form', this.productForm.querySelector("form").getAttribute("id"));
        this.embroideryDrawerText.setAttribute('form', this.productForm.querySelector("form").getAttribute("id"));
        this.embroideryAddCheckbox.setAttribute('form', this.productForm.querySelector("form").getAttribute("id"));
        this.embroideryAddCheckbox.checked = true;
        this.embroideryDrawerImageText.textContent = "text";

        document.body.addEventListener("click", this.onBodyClickEvent);
        document.dispatchEvent(
            new CustomEvent("theme:embroidery:open", { bubbles: !0 }),
        )
        document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 }),
        )

        this.embroideryDrawer.classList.add(selectors.open);
        this.embroideryDrawerIsOpen = true;
    }

    toggleEmbroideryDrawer() {
        if (!this.embroideryDrawerIsOpen) {
            this.openEmbroideryDrawer();
        } else {
            this.closeEmbroideryDrawer();
        }
    }
}

const embroideryDrawer = new EmbroideryDrawer();